var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"golf-outer loaded"},[_c('div',{staticClass:"home-page login-page"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.showLoader),expression:"showLoader"}],staticClass:"col-md-12"},[_c('login-board',{on:{"showLoader":function($event){return _vm.$emit('showLoader')}}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }